import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * Reconstructed, not vendored (docs/337): Mantis Free's own `components/Logo/` pulls raster/SVG
 * image assets from `assets/images/` this evaluation build has no equivalent of — a plain
 * wordmark reads fine for an internal admin tool and needs zero binary assets.
 */
export function Logo() {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: 1.5,
          bgcolor: "primary.main",
          color: "primary.contrastText",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 14,
          flexShrink: 0,
        }}
      >
        E
      </Box>
      <Typography variant="subtitle1" noWrap sx={{ fontWeight: 700 }}>
        Equipped Admin
      </Typography>
    </Box>
  );
}
